var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"like"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.liked),expression:"liked"}],attrs:{"src":_vm.likeImg,"alt":""}}),_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.liked),expression:"!liked"}],attrs:{"src":_vm.unlikeImg,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }